import styled from 'styled-components';

export const GameStateSwitch = styled.div`
  display: flex;
`;

export const ControlsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;
